/* 🤖 this file was generated by svg-to-ts */
export const emperorIconFileSync: {
  name: 'file_sync';
  data: string;
} = {
  name: 'file_sync',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M4 9h8v2H4Z"/><path d="M4 13h6v2H4Z"/><path d="M2 2h10v4h4v4h2V4.586L13.414 0H2C.897 0 0 .898 0 2v18c0 1.1.897 2 2 2h8v-2H2V2Z"/><path d="M18 12c-3.31 0-6 2.69-6 6h2c0-2.21 1.79-4 4-4 2.2 0 4 1.79 4 4 0 2.2-1.8 4-4 4 -1.07 0-2.074-.42-2.78-1.12l-.05-.06 1.82-1.83h-5v5l1.75-1.76c1.13 1.13 2.63 1.75 4.243 1.75 3.3 0 6-2.7 6-6 0-3.31-2.7-6-6-6Z"/></g></svg>`
};
